export default "__VITE_ASSET__Clgg6eKG__"